/* eslint eqeqeq: 0 */
import contains from "../../staff/utils/contains";

export default function updateDate(constants) {
  return (state = new Date(), action) => {
    if (contains(action.type, constants)) {
      if (action.reload == false) {
        return state;
      }

      return new Date();
    }

    return state;
  };
}
